import { getWindowTitle } from 'mini-window-title/lib/getWindowTitle';

export default function changeTitleForClearingRedDot() {
    document.title = 'clear-red-dot';
    setTimeout(() => {
        document.title = getWindowTitle();
    }, 200);
}
